import React, { useState } from 'react';



import "@fontsource/mulish"; // Defaults to weight 400.

import { makeStyles } from '@material-ui/core/styles';



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as star1} from "@fortawesome/pro-regular-svg-icons";
import { faStar as star2} from "@fortawesome/pro-solid-svg-icons";

import InputDialog from './InputDialog';

import { capitalizeFirstLetter } from './Utils';

import "@fontsource/mulish"; // Defaults to weight 400.

const useStyles = makeStyles(theme => ({
    fieldNameAndValue: {
        fontFamily:'Mulish', 
        fontWeight: '200',     
        backgroundColor: '#F3F3F3',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding : '5px',       
        marginBottom: '.2em',

    }, 
    titleAndFieldsBlock : {
        
        paddingTop: "10px",
        paddingLeft:'.5em',
        // maxHeight: '2.5em',
        // overflow: 'hidden',
    },
    fieldName: {
        fontWeight: 'normal',
        fontSize:14,
        paddingLeft:'.5em',
    },
    fieldValue: {
        fontWeight: 'normal',
        fontSize: 14,
        paddingLeft:'.5em',

        width: '200px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    list:{ 
        paddingLeft: '3%', 
    },
    star: {
        color: '#FFCB66',
    }


   
    }));



function InfoNode(props) {
   
  const classes = useStyles();

  const [fieldSet, setFieldSet] = useState(props.fieldSet);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogDefaultFieldValue, setDialogDefaultFieldValue] = useState();




  const nodePath = props.nodePath + "-" + props.title;
//   console.log("nodepath: ", nodePath);


  const propertyNames=[];
  const propertyValues=[];
  const childNodeNames=[];
  const childNodeObjects=[];
  
  function traverse(o) {
    for (var i in o) {
        if (o[i] !== null && typeof(o[i])=="object") {          
            childNodeNames.push(i);
            childNodeObjects.push(o[i]);
        }
        else if (o[i] !== null){ // && typeof(o[i])=="string") {
            propertyNames.push(i);
            propertyValues.push(o[i]+''); {/* concatenation to display boolean values */}
        }
    }


  }

  function getStar(path) {
    var star = star1; //unstarred

    if (fieldSet.has(path)) //starred
        star=star2;

    return star;
  }

  traverse(props.jsonObject);


  const handleClick = (nodePath) => {              
        
    if (!fieldSet.has(nodePath)) {
        fieldSet.add(nodePath);
        setFieldSet(new Set(fieldSet)) ;     //new shallow copy to trigger re-render
        props.addDataField(nodePath);

        setDialogDefaultFieldValue(nodePath);
        setDialogOpen(true); //open dialog for display-name

    }
    else {       
        fieldSet.delete(nodePath);
        setFieldSet(new Set(fieldSet)) ;     //new shallow copy to trigger re-render
        props.removeDataField(nodePath);
    }   
    
   }
 
   
   const removeDataField = (nodePath) => {
       props.removeDataField(nodePath);
       console.log("removed data field", nodePath );
   }  

 
  return (  
        
    <div>
          
        {dialogOpen && <InputDialog setDialogOpen={setDialogOpen} defaultFieldValue={dialogDefaultFieldValue} 
                setDisplayName={props.setDisplayName} toggleDataField={handleClick} />}

        <div className={classes.titleAndFieldsBlock}>

            {props.depth>0 && <hr />}
        
            <div>{capitalizeFirstLetter(props.title)}</div>  
                
                {/* Field names and values */}
                < ul className={classes.list}>
                    {propertyNames.map((value, index) => {
                        return <div key={nodePath+value} className={classes.fieldNameAndValue} onClick={_=>handleClick(nodePath + "-" + value)} >

                            <FontAwesomeIcon className={classes.star} icon={getStar(nodePath + "-" + value)} /> 
                            <div className={classes.fieldName}> {value}: </div> 
                            <div className={classes.fieldValue}>{propertyValues[index]} </div>                         

                        </div>
                    })}
                </ul>


        </div>

        {/* Child components */}
        { props.depth<10000 &&
            < ul className={classes.list}>
            {childNodeNames.map((value, index) => {
                return <div  key={nodePath+value}>
                    {<InfoNode title={value} depth={props.depth+1} jsonObject={childNodeObjects[index]} nodePath={nodePath} fieldSet={props.fieldSet}
                            addDataField={props.addDataField} removeDataField={props.removeDataField} setDisplayName={props.setDisplayName}/>}

                </div>
            })}
        </ul>
        }
   

    </div> 

  );
}


export default InfoNode;
